export default {
  init() {
    const $event_register = $('.event_register');
    const $mv_events_page = $('.mv_events').length;
    const $close_modal = $('.close_modal_redirect');

    if ($mv_events_page && $event_register.length) {
      $('body').addClass("no-scroll");
      $('#event_register_modal').addClass('is-open');
    }

    if ($close_modal.length) {
      $(document).keyup(function(e) {
        if (e.key === "Escape") {
          window.location.replace(wp.site_url);
          // Laikinai isjungiam
          // $('body').removeClass("no-scroll");
          // $('#event_register_modal').removeClass('is-open');
        }
      });
    }

    $close_modal.on('click', function(e) {
      window.location.replace(wp.site_url);
      // Laikinai isjungiam
      // $('body').toggleClass("no-scroll");
      // $('#event_register_modal').toggleClass('is-open');

      e.preventDefault();
    });

    $event_register.on('click', function(e) {
      $('body').toggleClass("no-scroll");
      $('#event_register_modal').toggleClass('is-open');

      e.preventDefault();
    });

    $(document).on('submit', '#register_event', function(e) {

      $.ajax({
        type: "POST",
        url: 'https://mv-events.stag.artme.lt/api/v1/events/register',
        headers: {
          "Authorization": "Basic " + btoa("test@example.com:12345678")
        },
        data: $(this).serializeArray(),
        success: function() {

          $('#errors').html('');
          $('#register_event')[0].reset();

          $('#event_registration_outer').addClass('hidden');
          $('#event_registration_success').removeClass('hidden');

          setTimeout(() => {
            $('body').toggleClass("no-scroll");
            $('#event_register_modal').toggleClass('is-open');
          },2500);

        },
        error: function(response) {

          const errors_obj = response.responseJSON.errors;
          let errors_html = '';

          errors_html = '';

          Object.keys(errors_obj).forEach((field) => {
            errors_html += '<li>';
            errors_html += errors_obj[field];
            errors_html += '</li>';
          });

          errors_html += '</ul>';

          $('#errors').html(errors_html);
        },
        dataType: 'json'
      });

      e.preventDefault();
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/events.js